import { Link } from "react-router-dom";
import { dailyDevo } from "@/data/brand";

export const NavBrand = ({ user }) => (
  <Link to="/dashboard" className="flex items-center gap-3" data-testid="nav-brand-link">
    <span className="flex h-11 w-11 items-center justify-center overflow-hidden rounded-full bg-white shadow-[0_6px_18px_rgba(26,54,38,0.12)]" data-testid="nav-brand-icon">
      <img src={dailyDevo.logoUrl} alt="DailyDevo logo" className="h-full w-full object-cover" data-testid="nav-dailydevo-logo" />
    </span>
    <span>
      <span className="block font-serif-display text-2xl font-semibold text-[#1A3626]" data-testid="nav-app-title">Fruitful</span>
      <span className="block text-xs uppercase tracking-[0.2em] text-[#8C9B90]" data-testid="nav-user-name">dailydevo.ca · {user?.name || "Reflection"}</span>
    </span>
  </Link>
);